import { render, staticRenderFns } from "./Salepoint.vue?vue&type=template&id=cb7e06d6&scoped=true"
import script from "./Salepoint.vue?vue&type=script&lang=js"
export * from "./Salepoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7e06d6",
  null
  
)

export default component.exports